export default {
  title: 'Reservierungsdienst ist für das Unternehmen deaktiviert',
  description:
    'Der Reservierungsdienst ist derzeit inaktiv für dieses Unternehmen. Sie können ihn unter Dienste aktivieren.',
  button: {
    settings: 'Zu den Einstellungen',
  },
};
